module.exports = __webpack_public_path__ + "static/media/dashboard-icon-inactive.7db0138c.svg";